export default "__VITE_ASSET__Xy$75WnR__"